import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";
import CmsLanguageProxy from "@/helpers/editor/blocks/CmsLanguageProxy.js";
import CmsMediaQuery from "@/helpers/editor/blocks/CmsMediaQuery.js";
import NetworkV2 from "@vue-components/helpers/NetworkV2.js";
import store from "@/store.js"

/**
 * A block is made of several primitive components such as text, button, icon, image...
 * @abstract
 */
export default class CmsComponent extends CmsBaseClass {
    get allowBinding() {
        return false;
    }
    get allowMediaQuery() {
        return false;
    }
    get ignoredFields() {
        return [`mediaProxy`, `languageProxy`, `expanded`, `review`];
    }
    get languageProxyFields() {
        return [];
    }
    get translationFields() {
        return [];
    }
    get reviewFields() {
        return [];
    }

    constructor(data) {
        super(data);

        // object to hold mobile, kiosk and tablet variants
        this.mediaQuery = new CmsMediaQuery(this.mediaQuery);

        // The Media Proxy will use the component values or the one from mediaQuery with the device and preview
        this.mediaProxy = this.mediaQuery.createProxy(this, `compMediaProxy`);
        this.languageProxy = CmsLanguageProxy.createProxy(this);

        if (!data) {
            this.active = data !== false;
            this.expanded = true; // editor only
            this.required = false;
            this.spacing = 10; // margin between previous block

            this.useBinding = false;
            this.itemField = null;
            // there is no need for css at the component level, it should be in the block instead
            // this.css = ``;
        }

        if (!this.plugins) {
            this.plugins = {};
        }
    }

    applyChanges(language) {

    }

    isVisible() {
        if (!this.active) {
            return false;
        } else if (!this.mediaQuery) {
            // this should never happen
            return true;
        } else if (store.state.displayMode === `kiosk`) {
            if (this.isWheelchairMode) {
                return this.mediaQuery.wheelchair.visible && this.mediaQuery.kiosk.visible;
            } else {
                return this.mediaQuery.kiosk.visible;
            }
        } else if (store.state.displayMode === `tablet`) {
            return this.mediaQuery.tablet.visible;
        } else if (store.state.displayMode === `mobile`) {
            return this.mediaQuery.mobile.visible;
        } else {
            return this.mediaQuery.desktop.visible;
        }
    }

    enableBinding() {
        this.useBinding = true;
    }

    async translate(from, to, replaceAll = false, context = null) {
        this.applyChanges(from);

        if (this.translationFields.length === 0 || !this.active)
            return;

        for (let field of this.translationFields) {
            if (!replaceAll && !isStringEmpty(this[field][to]) && this[field][to] !== `<br>` || isStringEmpty(this[field][from]))
                return;

            const params = {
                text: this[field][from],
                from: from,
                to: to,
            }

            if (context) {
                params.context = context;
            }

            try {
                const resp = await NetworkV2.post(`/translate`, params, {system_api: true, timeout: 300000});

                    this[field][to] = resp.data;
                } catch (e) {
                    console.error(e);
                }
            }
    }

    resetLanguageTexts(language) {
        if (!this.text || !this.active)
            return;

        this.text[language] = ``;
        this.newText[language] = ``;
    }

    swapLanguageTexts() {
        if (!this.text || !this.active)
            return;

        const fr = this.text.fr
        this.text.fr = this.text.en;
        this.text.en = fr;
    }

    /**
     * To provide refactoring compatibility only
     * @param oldField {string} old key (ex: height))
     * @param newField {string} new key (ex: size)
     */
    renameField(oldField, newField) {
        if (this.hasOwnProperty(oldField) && !this.hasOwnProperty(newField)) {
            this[newField] = this[oldField];
            delete this[oldField];
            const devices = [`mobile`, `tablet`, `kiosk`];
            for (let device of devices) {
                if (this.mediaQuery[device].hasOwnProperty(oldField) && !this.mediaQuery[device].hasOwnProperty(newField)) {
                    this.mediaQuery[device][newField] = this.mediaQuery[device][oldField];
                    delete this.mediaQuery[device][oldField];
                }
            }
        }
    }

    updateReview() {
        this.review = [];
        return this.review;
    }
}
